import stataImage from '../assets/images/languages/stata.png';
import sasImg from '../assets/images/languages/sas1.png';
import RLanguage from '../assets/images/languages/r1.png';
import biImg from '../assets/images/languages/bi.png';
import spssImg from '../assets/images/spss.png';

export const PROGRAMMING_LANUGAGES = [
    { key: "sas", label: "SAS", value: "sas", image: sasImg },
    { key: "R", label: "R | RStudio", value: "R", image: RLanguage },
    { key: "spss", label: "SPSS", value: "spss", image: spssImg },
    { key: "powerBI", label: "Power BI", value: "powerbi", image: biImg },
    { key: "stata", label: "Stata", value: "stata", image: stataImage },
];